import styled from 'styled-components';
import { ReactComponent as Reports } from '@ubeya/shared-web/assets/BookingBoard/stats.svg';
import { ReactComponent as TimesheetWorkflows } from '@ubeya/shared-web/assets/tasks.svg';
import { ReactComponent as Workers } from '../../employee.svg';
import { ReactComponent as Feed } from './feed.svg';
import { ReactComponent as AppStore } from './blocks.svg';
import { ReactComponent as Billing } from './card.svg';
import { ReactComponent as Compliance } from './compliance.svg';
import { ReactComponent as ExternalTimesheet } from './external-timesheet.svg';
import { ReactComponent as Invoices } from './invoices.svg';
import { ReactComponent as Settings } from './settings.svg';
import { ReactComponent as Timesheet } from './timesheet.svg';
import { ReactComponent as Payments } from './cards.svg';
import { ReactComponent as Payroll } from './finance.svg';
import { ReactComponent as Statements } from './statements.svg';
import { ReactComponent as Workflows } from './workflows.svg';
import { ReactComponent as NotificationSettings } from './settings-notification.svg';
import { ReactComponent as PayrollHistory } from './payroll-history.svg';
import { ReactComponent as BaseAdminSettings } from './admin-settings.svg';
import { ReactComponent as ReportsBi } from './bi.svg';

const AdminSettings = styled(BaseAdminSettings)`
  path {
    fill: black;
  }
`;

const SubmoduleIcons = {
  Workers,
  Settings,
  Feed,
  AppStore,
  Billing,
  Invoices,
  Payments,
  Payroll,
  Workflows,
  Statements,
  Timesheet,
  ExternalTimesheet,
  TimesheetWorkflows,
  NotificationSettings,
  Compliance,
  PayrollHistory,
  AdminSettings,
  Reports,
  ReportsBi
};

export default SubmoduleIcons;
